import { useQuery } from "react-query";
import { getOfficeApplianceById } from "../api/officeApplianceService";

export const useGetOfficeApplianceById = (applianceId) => {
  return useQuery(
    ["OfficeApplianceById", applianceId],
    () => getOfficeApplianceById(applianceId),
    { refetchOnWindowFocus: false }
  );
};
